module.exports = __webpack_public_path__ + "img/shared_group.5697d660.svg";